export const CATALOG_QUERY = `
  SELECT
    b.id AS book_id,
    b.name AS book_name,
    b.testament,
    v.chapter,
    MAX(v.verse) AS verse_count
  FROM books b
  JOIN kjv_verses v ON v.book_id = b.id
  GROUP BY b.id, b.name, b.testament, v.chapter
  ORDER BY b.id, v.chapter
`;

export const CHAPTER_VERSES_QUERY = `
  SELECT verse, text
  FROM kjv_verses
  WHERE book_id = ? AND chapter = ?
  ORDER BY verse
`;

export const GREEK_SOURCE_QUERY = `
  SELECT verse, word_num, text
  FROM greek_nt_words
  WHERE book_id = ? AND chapter = ?
  ORDER BY verse, word_num
`;

export const HEBREW_SOURCE_QUERY = `
  SELECT verse, word_num, text
  FROM hebrew_ot_words
  WHERE book_id = ? AND chapter = ?
  ORDER BY verse, word_num
`;

export const LXX_SOURCE_QUERY = `
  SELECT verse, word_num, text
  FROM lxx_words
  WHERE book_id = ? AND chapter = ?
  ORDER BY verse, word_num
`;

export const CROSS_REFERENCES_QUERY = `
  SELECT
    cr.id,
    cr.from_verse,
    cr.to_book_id,
    b.name AS to_book_name,
    cr.to_chapter,
    cr.to_verse,
    cr.to_verse_end,
    cr.votes,
    kv.verse AS target_verse,
    kv.text AS target_text
  FROM cross_references cr
  JOIN books b ON b.id = cr.to_book_id
  LEFT JOIN kjv_verses kv
    ON kv.book_id = cr.to_book_id
   AND kv.chapter = cr.to_chapter
   AND kv.verse BETWEEN cr.to_verse AND COALESCE(cr.to_verse_end, cr.to_verse)
  WHERE cr.from_book_id = ? AND cr.from_chapter = ?
  ORDER BY cr.from_verse, cr.votes DESC, cr.id, kv.verse
`;

export function buildVerseSearchExpression(value: string): string | null {
  const tokens = value
    .normalize('NFKC')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  if (tokens.length === 0) {
    return null;
  }

  return tokens.map((token) => `${token}*`).join(' AND ');
}

export function buildVerseSearchQuery(limit: number | null = null): string {
  return `
    SELECT
      v.book_id,
      b.name AS book_name,
      v.chapter,
      v.verse,
      v.text
    FROM kjv_verses_fts f
    JOIN kjv_verses v ON v.id = f.rowid
    JOIN books b ON b.id = v.book_id
    WHERE kjv_verses_fts MATCH ?
    ORDER BY v.book_id, v.chapter, v.verse
    ${limit === null ? '' : `LIMIT ${limit}`}
  `;
}
